import { zCurrency } from "@redotech/money/usd-amounts";
import { SubscriptionProduct } from "@redotech/redo-billing-common/unified-billing/enums";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export type BillingProductSummary = z.infer<typeof billingProductSummary>;
const billingProductSummary = z.object({
  product: createEnum(SubscriptionProduct),
  /** Calendar day the merchant is billed on, as the Bills page shows it. */
  billedDate: zExt.plainDate(),
  totalInvoiceAmount: z.number(),
  /** Before bundle discounts; equals totalInvoiceAmount when none applies. */
  listInvoiceAmount: z.number(),
  /** Bill currency. Foreign charges are struck into it before totalling. */
  currency: zCurrency,
});

/**
 * One entry per product the team is actually billed for; absent means no tile.
 */
export const getBillingProductSummaries = {
  name: "getBillingProductSummaries" as const,
  input: z.null(),
  output: z.array(billingProductSummary),
};
